const residence = document.querySelector('.residence');
const sliderResidence = document.querySelector('.residence__slider');

if (sliderResidence) {
	const swiper = new Swiper(sliderResidence, {
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		speed: 2200,
		navigation: {
			nextEl: '.residence__slider-button-next',
			prevEl: '.residence__slider-button-prev',
		},
		pagination: {
			el: '.residence__slider-pagination',
			type: 'fraction',
			currentClass: 'residence__slider-pagination-current',
			totalClass: 'residence__slider-pagination-total',
		},
		on: {
			slideChange: function () {
				if (residence) {
					residence.dataset.tab = this.slides[this.activeIndex].dataset.tab;
				}
			}
		}
	});

	const residenceTabs = document.querySelectorAll('.residence__tab');

	if (residenceTabs.length) {
		const onResidenceTabClick = function () {
			swiper.slideTo(this.dataset.index);
		};

		residenceTabs.forEach((tab) => {
			tab.addEventListener('click', onResidenceTabClick);
		});
	}

}
